<template>
  <div class="home">
    <!-- 英雄区域 -->
    <section class="hero">
      <div class="container">
        <div class="hero-content">
          <h1 class="hero-title">掌柜助手</h1>
          <p class="hero-subtitle">自动后台飞单，服务稳定运行，告别电脑挂单</p>
          <div class="hero-buttons">
            <router-link to="/download" class="btn btn-primary">产品下载</router-link>
            <a href="#contact" class="btn btn-secondary">联系客服</a>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务特色 -->
    <section class="features section">
      <div class="container">
        <h2 class="section-title">核心服务</h2>
        <div class="features-grid">
          <div class="feature-card card">
            <div class="feature-icon">
              <i class="icon-robot"></i>
            </div>
            <h3>掌柜助手</h3>
            <p>用户H5、用户APP、群主PC、群主H5、群主APP，安卓IOS多端服务</p>
            <router-link to="/introduce" class="btn">了解更多</router-link>
          </div>
          <div class="feature-card card">
            <div class="feature-icon">
              <i class="icon-server"></i>
            </div>
            <h3>多盘自助</h3>
            <p>无需电脑挂盘，多盘配置均在后台自行操作，且不需要挂机</p>
            <a href="#contact" class="btn">立即咨询</a>
          </div>
          <div class="feature-card card">
            <div class="feature-icon">
              <i class="icon-support"></i>
            </div>
            <h3>技术支持</h3>
            <p>支持测试，支持远程协助，先测试，再开号。服务时间:早9点到晚上12点！</p>
            <a href="#contact" class="btn">联系客服</a>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品展示 -->
    <section class="products section">
      <div class="container">
        <div class="products-grid">
          <div class="product-item">
            <div class="product-content">
              <h2>掌柜助手</h2>
              <h3>WEB网页后台</h3>
              <p>全新WEB机器人架构，着重优化使用体验和数据安全。支持20+款热门游戏，支持多游戏独立设置，支持群主每日自动返水，所有群主线路均使用在线防御，确保数据安全体验流畅。打盘助手多线路节点获取注单，支持所有热门平台，针对多个热门平台独立优化，体验更好飞单更快更稳定。</p>
              <div class="product-buttons">
                <router-link to="/download" class="btn">立即下载</router-link>
                <router-link to="/introduce" class="btn btn-secondary">了解更多</router-link>
              </div>
            </div>
          </div>
          
          <div class="product-item">
            <div class="product-content">
              <h2>掌柜助手</h2>
              <h3>APP助手端</h3>
              <p>群主身份登录APP，从此摆脱电脑束缚，走到哪玩到哪。群主APP体验更流畅使用更方便，支持WEB机器人所有功能和设置，群内消息实时查看，极速推送，不错过任何一个帮您赚钱的机会。提供IOS&Android原生APP下载，支持TF签，企业签，超签等多种安全下载途径。</p>
              <div class="product-buttons">
                <router-link to="/download" class="btn">立即下载</router-link>
                <router-link to="/introduce" class="btn btn-secondary">了解更多</router-link>
              </div>
            </div>
          </div>

          <div class="product-item">
            <div class="product-content">
              <h2>服务保障</h2>
              <h3>支持测试</h3>
              <p>支持测试，支持远程协助，先测试，再开号。服务时间:早9点到晚上12点！欢迎合作！</p>
              <h3>多线BGP机房</h3>
              <p>电信、联通、移动、多线BGP机房：根据应用需求线路可任意选择。</p>
              <div class="product-buttons">
                <a href="#contact" class="btn">联系客服</a>
                <router-link to="/agent" class="btn btn-secondary">代理加盟</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section id="contact" class="contact section">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <div class="contact-content">
          <div class="contact-info card">
            <h3>客服信息</h3>
            <p>服务时间：早9点到晚上12点</p>
            <p>支持测试，支持远程协助</p>
            <p>先测试，再开号</p>
            <p>技术在线，实时协助</p>
            <div class="contact-buttons">
              <!-- <a href="https://t.me/ZG000001" class="btn">Telegram</a> -->
              <!-- <a href="https://t.me/zg999999" class="btn">Telegram</a> -->
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home',
  mounted() {
    // 添加页面动画效果
    this.animateOnScroll()
  },
  methods: {
    animateOnScroll() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in')
          }
        })
      })

      const cards = document.querySelectorAll('.card, .product-item')
      cards.forEach(card => observer.observe(card))
    }
  }
}
</script>

<style scoped>
.hero {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 100px 0;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="75" cy="75" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="50" cy="10" r="1" fill="rgba(255,255,255,0.05)"/><circle cx="20" cy="80" r="1" fill="rgba(255,255,255,0.05)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  opacity: 0.3;
}

.hero-content {
  position: relative;
  z-index: 1;
}

.hero-title {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.hero-subtitle {
  font-size: 24px;
  margin-bottom: 40px;
  opacity: 0.9;
}

.hero-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 50px;
}

.feature-card {
  text-align: center;
  padding: 40px 30px;
}

.feature-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: linear-gradient(45deg, #667eea, #764ba2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: white;
}

.feature-card h3 {
  font-size: 24px;
  margin-bottom: 15px;
  color: #333;
}

.feature-card p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 25px;
}

.products {
  background: white;
}

.products-grid {
  display: grid;
  gap: 40px;
}

.product-item {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 15px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.product-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.product-content h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 10px;
}

.product-content h3 {
  font-size: 20px;
  color: #667eea;
  margin-bottom: 20px;
}

.product-content p {
  color: #666;
  line-height: 1.8;
  margin-bottom: 25px;
}

.product-buttons {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.contact {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
}

.contact .section-title {
  color: white;
}

.contact-content {
  display: flex;
  justify-content: center;
}

.contact-info {
  max-width: 500px;
  text-align: center;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.contact-info h3 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #3498db;
}

.contact-info p {
  margin-bottom: 10px;
  opacity: 0.9;
}

.contact-buttons {
  margin-top: 30px;
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

/* 图标样式 */
.icon-robot::before { content: '🤖'; }
.icon-server::before { content: '🖥️'; }
.icon-support::before { content: '🛠️'; }

/* 动画效果 */
.card, .product-item {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease;
}

.card.animate-in, .product-item.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero {
    padding: 60px 0;
  }
  
  .hero-title {
    font-size: 36px;
  }
  
  .hero-subtitle {
    font-size: 18px;
  }
  
  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .product-item {
    padding: 30px 20px;
  }
  
  .product-buttons {
    flex-direction: column;
  }
  
  .contact-buttons {
    flex-direction: column;
  }
}
</style>
